/* eslint-disable no-console */
export default {
    data() {
        return {
            // globaladd:true,
            // globaledit:true,
            // globaldelete:true
        }
    },

    mounted: function () {
        this.authenticatedOrRedirect();

    },
    methods: {
        checkPermissionFour(a, b, c, d) {
            let temp = {
              add: true,
              edit: true,
              delete: true
            };
            let permissionID = sessionStorage.getItem("permissionid").split(",");
            if (permissionID.some(e => e == 99)) {
              temp.add = false;
              temp.edit = false;
              temp.delete = false;
            } else {
              if (permissionID.some(e => e == a)) {
                temp.add = true;
                temp.edit = true;
                temp.delete = true;
              }
              if (permissionID.some(e => e == b)) {
                temp.add = false;
              }
              if (permissionID.some(e => e == c)) {
                temp.edit = false;
              }
              if (permissionID.some(e => e == d)) {
                temp.delete = false;
              }
            }
            return temp;
          },

        LogTrace(exception, methodname) {
          console.error(exception);
          console.log(methodname);
        },
        authenticatedOrRedirect() {
        },
        checkPermissionTwo(a, b) {

            let permissionID = sessionStorage.getItem('permissionid').split(',');
            for (let item of permissionID) {
                if (item == 99 || item == b) return false;
                else if (item == a) return true;

            }
        },
      
    }
}